import React from "react";

/**
 * Inline "+N more" / "Show less" toggle for a capped header region.
 *
 * Split out of `DetailHeaderModelView.tsx` (module-size lane L17). Behaviour is
 * pinned by `tests/components-ui/DetailHeaderModelView.behaviour.test.tsx`.
 */
export function MoreToggle({
  hiddenCount,
  expanded,
  onToggle,
}: {
  hiddenCount: number;
  expanded: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="text-xs md:text-sm font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors"
    >
      {expanded ? "Show less" : `+${hiddenCount} more`}
    </button>
  );
}
